import type { MVRProductType } from 'api';

interface ProductTypeReadiness {
  productTypeParam: MVRProductType | null | undefined;
  isProductTypeReady: boolean;
}

export const resolveProductTypeReadiness = (
  productType: MVRProductType | null,
  requiresProductType: boolean,
): ProductTypeReadiness => ({
  productTypeParam: requiresProductType ? productType : undefined,
  isProductTypeReady: !requiresProductType || !!productType,
});
